export default "__VITE_ASSET__6fb3d8db__"